var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"warning","title":"以回款日期为统计单位对时段范围内的回款金额及回款数量进行统计"}}),_c('time-statistic',{ref:"timeStatistic"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }